import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getDashboardRoute } from '../utils/dashboardRoute';

export const ProtectedRoute = ({
  children,
  allowedRoles,
  allowPendingApproval = false,
}) => {
  const { isAuthenticated, loading, user, hasRole } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const companyStatus = user?.company?.status;
  const needsApproval =
    !user?.isSuperAdmin && user?.companyId && companyStatus && companyStatus !== 'ACTIVE';

  if (needsApproval && !allowPendingApproval) {
    return <Navigate to="/pending-approval" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !hasRole(allowedRoles)) {
    return <Navigate to={needsApproval ? '/pending-approval' : getDashboardRoute(user)} replace />;
  }

  return children;
};
